import { SortTitles } from '@components/Dashboard/components/DashboardProjects/components/SortSelect/constants'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type { SortType } from '@store/reducers/dashboard/types'
import type React from 'react'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { SortButton, SortOptions } from './components'

interface Props {
  onChange: (t: SortType) => void
  value: SortType
}

export const SortSelect: React.FC<Props> = ({ onChange, value }) => {
  const onClick = (path: string[]) => {
    const nextSort = path[0] as SortType

    if (nextSort === 'abc') {
      sendGtmEvent(GtmTriggerName.DASHBOARD_SORT_A_Z)
    }

    if (nextSort === 'created') {
      sendGtmEvent(GtmTriggerName.DASHBOARD_SORT_CREATED)
    }

    onChange(nextSort)
  }

  return (
    <DropdownMenu.Root onClick={onClick} content={SortOptions} active={value}>
      <SortButton title={SortTitles[value]} />
    </DropdownMenu.Root>
  )
}
